import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { css } from "styled-components";

export const PageColumn = styled.div`
  & {
    background-color: ${({ bgColor, theme }) =>
      bgColor ? bgColor : theme.colors.white};
    width: 100%;
    height: 100%;
    display: inline-block;
    display: ${({ centerContent }) =>
      centerContent ? "flex" : "inline-block"};
    ${({ centerContent }) =>
      centerContent &&
      css`
        flex-direction: column;
        justify-content: ${({ centerContent }) =>
          centerContent ? "center" : "flex-start"};
      `}

    ${media.greaterThan(breakpoints.ipad)`
    	color: white;
  	`}
  }
  &:nth-of-type(1) {
    flex-basis: ${({ centerContent, fullWidth, alignContentLeft }) =>
      fullWidth ? "100%" : centerContent ? "80%" : "65%"};
    padding-left: ${({ fullWidth, alignContentLeft, centerContent }) =>
      fullWidth ? "0" : alignContentLeft || centerContent ? "1rem" : "6rem"};

    ${media.lessThan(breakpoints.desktop)`
			padding-left:  ${({ fullWidth }) => (fullWidth ? "0" : "1rem")};
		  `};
    ${media.lessThan(breakpoints.ipad)`
			padding-left: 0;
  		`};
  }

  &:nth-of-type(2) {
    flex-basis: 35%;
    padding: 1rem 1rem 1rem 3rem;
  }
`;
